import React, { Component } from 'react';
import { MapController, MapView } from '@deck.gl/core';
import { DeckGL } from '@deck.gl/react';
import { DrawPolygonMode, EditableGeoJsonLayer, ModifyMode } from '@deck.gl-community/editable-layers';

export default class Lasso extends Component {
  constructor(props) {
    super(props);
    const views = new MapView({
      id: 'basemap',
      controller: {
        type: MapController,
      },
    });

    this.state = {
      data: {
        type: 'FeatureCollection',
        features: [],
      },
      mode: 'drawPolygon',
      selectedFeatureIndexes: [],
      views: null,
      defaultViews: views,
    };
  }

  _onLayerClick = (info) => {
    // console.log('onLayerClick', info); // eslint-disable-line
  };

  render() {
    // console.log('state', this.state.mode);
    const { changeViewport, changeData, height } = this.props;
    const lassoLayer = new EditableGeoJsonLayer({
      id: 'geojson-layer',
      data: this.state.data,
      mode: this.state.mode === 'modify' ? new ModifyMode() : new DrawPolygonMode(),
      selectedFeatureIndexes: this.state.selectedFeatureIndexes,
      onEdit: ({ updatedData, editType, featureIndexes, editContext }) => {
        // console.log('editType', editType, featureIndexes);
        if (editType === 'addFeature') {
          this.setState({
            data: updatedData,
          });
          this.setState({
            mode: 'modify',
            selectedFeatureIndexes: featureIndexes ? [...this.state.selectedFeatureIndexes, ...featureIndexes] : this.state.selectedFeatureIndexes,
          });
          changeData(updatedData);
          setTimeout(() => this.setState({ views: this.state.defaultViews }), 100);
        }
      },
    });

    return (
      <div>
        <DeckGL
          width="100%"
          height={height || '700px'}
          getCursor={(isGrabbing) => 'crosshair'}
          onClick={this._onLayerClick}
          viewState={this.props.viewport}
          onViewStateChange={({ viewState }) => changeViewport(viewState)}
          views={this.state.views}
          layers={[lassoLayer]}
        />
      </div>
    );
  }
}
